import { render } from "./AddShopDialog.vue?vue&type=template&id=77644059&scoped=true&ts=true"
import script from "./AddShopDialog.vue?vue&type=script&lang=ts"
export * from "./AddShopDialog.vue?vue&type=script&lang=ts"

import "./AddShopDialog.vue?vue&type=style&index=0&id=77644059&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77644059"]])

export default __exports__